<script>
import { api } from "@/state/services";
import { maskCpfCnpj, validateCpfCnpj } from "@/utils/masks";

export default {
  beforeCreate() {
    document.body.className = "auth";
  },
  data() {
    return {
      uuid: this.$route.params.uuid,
      ownerLoading: true,
      owner: null,
      ownerError: "",

      submitting: false,
      success: false,
      formError: "",

      cepLoading: false,
      cepFound: false,

      form: {
        name:       "",
        email:      "",
        cellphone:  "",
        document:   "",
        password:   "",
        confirm:    "",
        zipcode:    "",
        address:    "",
        number:     "",
        complement: "",
        district:   "",
        city:       "",
        state:      "",
      },
    };
  },
  computed: {
    cpfState() {
      const digits = this.form.document.replace(/\D/g, "");
      if (!digits) return null;
      if (digits.length < 11 || digits.length === 12 || digits.length === 13) return null;
      return validateCpfCnpj(this.form.document);
    },
  },
  created() {
    api.get("afiliados/register/" + this.uuid).then((r) => {
      if (r.data.status === "success") {
        this.owner = r.data.owner;
      } else {
        this.ownerError = "Link de convite inválido ou expirado.";
      }
    }).catch(() => {
      this.ownerError = "Não foi possível carregar as informações do convite.";
    }).finally(() => { this.ownerLoading = false; });
  },
  methods: {
    searchCep() {
      const cep = this.form.zipcode.replace(/\D/g, "");
      if (cep.length !== 8) return;

      this.cepLoading = true;
      this.cepFound = false;

      api.get("https://cep.m2n.com.br/" + cep).then((response) => {
        if (response.data.city) {
          if (response.data.address)  this.form.address  = response.data.address;
          if (response.data.district) this.form.district = response.data.district;
          this.form.city  = response.data.city;
          this.form.state = response.data.state;
          this.cepFound   = true;
        }
      }).catch(() => {}).finally(() => {
        this.cepLoading = false;
      });
    },

    maskCpfCnpj, // expose to template

    handleSubmit() {
      this.formError = "";
      const cpfDigits = this.form.document.replace(/\D/g, "");
      if (!cpfDigits) {
        this.formError = "Informe o CPF/CNPJ.";
        return;
      }
      if (!validateCpfCnpj(this.form.document)) {
        this.formError = "CPF/CNPJ inválido.";
        return;
      }
      if (this.form.password !== this.form.confirm) {
        this.formError = "As senhas não coincidem.";
        return;
      }
      if (this.form.password.length < 6) {
        this.formError = "A senha deve ter no mínimo 6 caracteres.";
        return;
      }

      this.submitting = true;
      api.post("afiliados/register/" + this.uuid, { ...this.form }).then((r) => {
        if (r.data.status === "success") {
          if (r.data.token) {
            localStorage.setItem("afiliado_token", r.data.token);
            localStorage.setItem("afiliado", JSON.stringify(r.data.afiliado));
          }
          this.success = true;
          setTimeout(() => { window.location.href = "https://afiliados.salesteams.com.br"; }, 2000);
        } else {
          this.formError = r.data.message || "Erro ao realizar cadastro.";
        }
      }).catch((e) => {
        this.formError =
          (e.response && e.response.data && e.response.data.message) ||
          "Erro ao realizar cadastro. Tente novamente.";
      }).finally(() => { this.submitting = false; });
    },
  },
};
</script>

<template>
  <div class="cad-page">
    <div class="cad-wrap">

      <div v-if="ownerLoading" class="text-center py-5">
        <b-spinner variant="secondary"></b-spinner>
      </div>

      <div v-else-if="ownerError" class="cad-card text-center py-5">
        <i class="mdi mdi-link-variant-off" style="font-size:3rem;color:var(--st-danger);"></i>
        <p class="mt-3 text-danger font-weight-bold mb-0">{{ ownerError }}</p>
      </div>

      <div v-else>
        <div class="cad-header">
          <img src="@/assets/images/logo.png" alt="Sales Teams" />
          <p class="cad-subtitle" v-if="owner">
            Você foi convidado por <strong>{{ owner.name }}</strong>
          </p>
        </div>

        <div class="cad-card">

          <div v-if="success" class="text-center py-4">
            <i class="mdi mdi-check-circle" style="font-size:4rem;color:var(--st-success);"></i>
            <h5 class="mt-3 font-weight-bold">Cadastro realizado com sucesso!</h5>
            <p class="text-muted mb-0">Redirecionando...</p>
          </div>

          <b-form v-else @submit.prevent="handleSubmit">
            <div v-if="formError" class="alert alert-danger py-2 small mb-4">{{ formError }}</div>

            <p class="cad-section-title">DADOS PESSOAIS</p>
            <div class="row no-gutters cad-row">
              <div class="col-12 cad-col">
                <b-form-group label="Nome completo *" class="mb-0">
                  <b-form-input v-model="form.name" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-6 cad-col">
                <b-form-group label="E-mail *" class="mb-0">
                  <b-form-input v-model="form.email" type="email" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-6 cad-col">
                <b-form-group label="Celular" class="mb-0">
                  <b-form-input v-model="form.cellphone"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 cad-col">
                <b-form-group label="CPF/CNPJ *" class="mb-0">
                  <b-form-input
                    :value="form.document"
                    :state="cpfState"
                    placeholder="000.000.000-00"
                    autocomplete="off"
                    required
                    @input="form.document = maskCpfCnpj($event)"
                  ></b-form-input>
                  <b-form-invalid-feedback>CPF/CNPJ inválido</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>

            <hr class="my-4" />

            <p class="cad-section-title">ENDEREÇO</p>
            <div class="row no-gutters cad-row">
              <div class="col-12 col-sm-3 cad-col">
                <b-form-group label="CEP" class="mb-0">
                  <div class="position-relative">
                    <b-form-input
                      v-model="form.zipcode"
                      v-mask="'#####-###'"
                      inputmode="numeric"
                      autocomplete="off"
                      @blur="searchCep"
                    ></b-form-input>
                    <b-spinner v-if="cepLoading" small class="cep-spinner"></b-spinner>
                  </div>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-6 cad-col">
                <b-form-group label="Endereço" class="mb-0">
                  <b-form-input v-model="form.address" autocomplete="off"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-3 cad-col">
                <b-form-group label="Número" class="mb-0">
                  <b-form-input v-model="form.number" autocomplete="off"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-6 cad-col">
                <b-form-group label="Complemento" class="mb-0">
                  <b-form-input v-model="form.complement" autocomplete="off"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-6 cad-col">
                <b-form-group label="Bairro" class="mb-0">
                  <b-form-input v-model="form.district" autocomplete="off"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-8 cad-col">
                <b-form-group label="Cidade" class="mb-0">
                  <b-form-input
                    v-model="form.city"
                    autocomplete="off"
                    :class="{ 'bg-soft-info': cepFound }"
                    :readonly="cepFound"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-4 cad-col">
                <b-form-group label="UF" class="mb-0">
                  <b-form-input
                    v-model="form.state"
                    autocomplete="off"
                    maxlength="2"
                    :class="{ 'bg-soft-info': cepFound }"
                    :readonly="cepFound"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <hr class="my-4" />

            <p class="cad-section-title">SENHA DE ACESSO</p>
            <div class="row no-gutters cad-row">
              <div class="col-12 col-sm-6 cad-col">
                <b-form-group label="Senha *" class="mb-0">
                  <b-form-input v-model="form.password" type="password" required minlength="6"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12 col-sm-6 cad-col">
                <b-form-group label="Confirmar Senha *" class="mb-0">
                  <b-form-input v-model="form.confirm" type="password" required></b-form-input>
                </b-form-group>
              </div>
            </div>

            <b-button :disabled="submitting" type="submit" class="cad-submit mt-3" block>
              <b-spinner v-if="submitting" small class="mr-1"></b-spinner>
              Cadastrar
            </b-button>

            <div class="text-center mt-3">
              <a href="https://afiliados.salesteams.com.br" class="text-muted small">Já tenho cadastro — Entrar</a>
            </div>
          </b-form>
        </div>

        <p class="cad-footer">&copy; {{ new Date().getFullYear() }} Sales Teams</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cad-page {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(160deg, var(--st-brand) 0%, var(--st-brand-start) 40%, var(--st-canvas) 40%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 48px 16px 64px;
  box-sizing: border-box;
}

.cad-wrap {
  width: 100%;
  max-width: 620px;
}

.cad-header {
  text-align: center;
  margin-bottom: 28px;
}

.cad-header img {
  max-width: 200px;
  width: 100%;
  filter: brightness(0) invert(1);
}

.cad-subtitle {
  color: rgba(255, 255, 255, 0.82);
  margin-top: 8px;
  margin-bottom: 0;
  font-size: .9rem;
}

.cad-card {
  background: var(--st-surface);
  border-radius: var(--st-radius-lg);
  box-shadow: var(--st-shadow-lg);
  padding: 32px;
}

@media (max-width: 480px) {
  .cad-card { padding: 20px 16px; }
  .cad-page  { padding: 24px 8px 40px; }
}

.cad-section-title {
  font-size: .72rem;
  font-weight: 700;
  color: var(--st-text-muted);
  letter-spacing: .06em;
  margin-bottom: 14px;
}

.cad-submit {
  background: var(--st-brand);
  border-color: var(--st-brand);
  color: var(--st-text-inverse);
  font-weight: 500;
  padding: .55rem;
  border-radius: var(--st-radius-sm);
}

.cad-submit:hover:not(:disabled) {
  background: var(--st-brand-start);
  border-color: var(--st-brand-start);
}

.cad-footer {
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: .78rem;
  margin-top: 20px;
  margin-bottom: 0;
}

.cep-spinner {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.cad-row {
  margin-bottom: -12px;
}

.cad-col {
  padding-right: 8px;
  padding-bottom: 12px;
}

.cad-col:last-child {
  padding-right: 0;
}
</style>
